import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_CONFIG } from '../config/api.config';

export interface UserSearchResponse {
  success: boolean;
  message: string;
  data?: {
    profile: {
      PK: string;
      SK: string;
      ItemType: string;
      userid: string;
      username: string;
      firstname: string;
      lastname: string;
      email: string;
      phone: string | null;
      GSI1PK: string;
      GSI1SK: string;
      createdAt: string;
      updatedAt: string;
    };
    role: {
      PK: string;
      SK: string;
      ItemType: string;
      role: string;
      createdAt: string;
      updatedAt: string;
    };
    facturacion: any;
  };
  timestamp: string;
}

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(private http: HttpClient) {}

  searchByEmail(email: string): Observable<UserSearchResponse> {
    return this.http.get<UserSearchResponse>(
      `${API_CONFIG.baseUrl}${API_CONFIG.endpoints.users.searchByEmail}?email=${encodeURIComponent(email)}`,
      {
        headers: {
          'x-api-key': API_CONFIG.api_key
        }
      }
    );
  }
}
